interface IAssetValue {
    stringValue?: string | null;
    boolValue?: boolean | null;
    intValue?: number | null;
    value?: string | null;
    credentialUsername?: string | null;
    credentialPassword?: string | null;
    externalName?: string | null;
    credentialStoreId?: number;
}
export type IAssetType = 'Text' | 'Bool' | 'Integer' | 'Credential';

export interface IAsset extends IAssetValue {
    id: number;
    name: string;
    description?: string;
    value: string | null;
    hasDefaultValue: boolean | null;
    type: IAssetType;
    robotId?: number;
    scope: string;
    canBeDeleted: boolean;
    robotValues?: Array<IAssetRobot>;
}

export interface IAssetRobot extends IAssetValue {
    id: number;
    robotId: number;
    robotName: string;
    type: IAssetType;
}

export enum AssetScope {
    Global,
    PerRobot,
}
